module.exports = __webpack_public_path__ + "static/media/BurnoutActive.264b4ab0.svg";